/* eslint import/prefer-default-export: 0 */

import common from '@common';
import * as t from './action_types';

const {
  utils: {
    dimension: { getDimensions },
  },
} = common;

/**
 * {
 *   height - window height,
 *   state - window state: mobile/desktop,
 *   small_desktop_state - window state: true / false,
 *   width - window width
 * }
 */
const initialState = getDimensions();

export default (state = initialState, action) => {
  switch (action.type) {
    case t.ACTIVE_DIMENSIONS_UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
